import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from "../../services/auth.service";
import { HttpService } from "../../services/http.service";
import { Observable, Subscription } from "rxjs";
import Swal from "sweetalert2";

@Injectable()
export class AuthGuard implements CanActivate {
  private authSubscription: Subscription;

  constructor(
    private router: Router,
    private auth: AuthService,
    private service: HttpService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    return new Promise(async (resolve) => {
      // Limpiar suscripciones previas
      if (this.authSubscription) {
        this.authSubscription.unsubscribe();
      }

      try {
        // Obtener usuario desde el backend (que ya valida con Firebase Auth)
        const userLocal = await this.auth.getUser2();

        if (!userLocal || !userLocal.uid) {
          // No hay usuario autenticado
          this.redirectToLogin(state.url);
          resolve(false);
          return;
        }

        // Verificar permisos administrativos
        if (userLocal.is_admin === true || userLocal.is_admin_commerce === true) {
          // Usuario tiene permisos, permitir acceso
          resolve(true);
        } else {
          // Usuario sin permisos administrativos
          await this.showAccessDeniedAlert();
          await this.auth.logout();
          this.router.navigate(['/auth/login']);
          resolve(false);
        }

      } catch (error) {
        // Error al obtener usuario o usuario no autenticado
        this.redirectToLogin(state.url);
        resolve(false);
      }
    });
  }

  private redirectToLogin(returnUrl: string): void {
    this.router.navigate(['/auth/login'], { 
      queryParams: { returnUrl } 
    });
  }

  private showAccessDeniedAlert(): Promise<any> {
    return Swal.fire({
      icon: 'error',
      title: 'Access Denied',
      text: 'Your account does not have administrative permissions.',
      showConfirmButton: true,
      confirmButtonText: 'OK'
    });
  }

  ngOnDestroy(): void {
    // Limpiar suscripciones al destruir el guard
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }
}
